export default {
  Detail: {
    title: "Cấp phát theo nhân viên",
    titleOrganization: "Cấp phát theo phòng ban",
    ProcessDate: "Ngày cấp phát",
    Reason: "Lý do cấp phát",
    attach: "Đính kèm",
    addEmployee: "Thêm nhân viên",
    assetbyEmployee: "Tài sản được cấp phát",
    attachFile: "Tệp đính kèm",
    addAsset: "Thêm dòng",
    quickSearch: "Chọn nhanh",
    assetType: "Loại tài sản",
    quantity: "Số lượng",
    assetStatus: "Tình trạng",
    QuantityLost: "SL mất",
    assetCode: "Mã tài sản",
    assetName: "Tên tài sản",
    UserType: "Đối tượng sử dụng",
    EmployeeUse: "Nhân viên sử dụng",
    OrganizationUnitUse: "Đơn vị sử dụng",
    location: "Vị trí tài sản",
    specification: "Quy cách",
    addAttach: "Thêm đính kèm",
    name: "Tệp đính kèm",
    size: "Dung lượng",
    dowload: "Tải về",
    JobPosition: "Vị trí tài sản",
    AssetStatus: "Trạng thái",
    EmptyAttact: "Chưa có tệp đính kèm nào",
    InfoAssetContent: "Đã cấp được {0} trên {1} tài sản theo định mức",
    quantityAllo: "SL cấp phát",
    locationName: "Tên vị trí tài sản",
    locationCode: "Mã vị trí tài sản",
    quantityRemain: "Số lượng tồn",
    Representative: "Người đại diện",
    notUsingQuantity: "Số lượng chưa sử dụng",
    notUsingQuantityShort: "SL chưa sử dụng",
    allocationQuantity: "Số lượng cấp phát",
    allocationQuantityShort: "SL cấp phát",
    LostReason: "Lý do mất",
    OccurenceDateInValid:
      "Ngày đánh dấu mất không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
  },
  Validate: {
    notSelectAsset: "Chưa chọn tài sản. Vui lòng kiểm tra lại.",
  },
};
